// Kit status names - rows in the shared `statuses` table (type = 'kit'),
// referenced by `kits.status_id` (see migration 20260618020000_kits_status_id.sql).
// The API exposes the status as one of these names.
export const KIT_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  MAINTENANCE: "maintenance",
} as const;

export type KitStatus = (typeof KIT_STATUSES)[keyof typeof KIT_STATUSES];

export const KIT_STATUS_LABELS: Record<KitStatus, string> = {
  [KIT_STATUSES.ACTIVE]: "Active",
  [KIT_STATUSES.INACTIVE]: "Inactive",
  [KIT_STATUSES.MAINTENANCE]: "Maintenance",
};

export const KIT_STATUS_OPTIONS: { value: KitStatus; label: string }[] = [
  { value: KIT_STATUSES.ACTIVE, label: KIT_STATUS_LABELS.active },
  { value: KIT_STATUSES.INACTIVE, label: KIT_STATUS_LABELS.inactive },
  { value: KIT_STATUSES.MAINTENANCE, label: KIT_STATUS_LABELS.maintenance },
];
